import { orderStatusFormStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusForm";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

const formLabelStyles = {
    cssOverrides: {
        formField: css`
            width: auto;
            font-size: ${TYPOGRAPHY.size.small};
            color: ${COLORS.secondary.base};

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["0", "50px", null, null, null], properties: ["margin-right"] }],
                    mediaOptions.min,
                )}

            label {
                font-weight: ${TYPOGRAPHY.weight.medium};
            }
        `,
        formInputWrapper: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["30px", "0", null, null, null], properties: ["margin-bottom"] }],
                    mediaOptions.min,
                )}
        `,
        descriptionWrapper: css`
            display: block;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, "absolute", null, null, null], properties: ["position"] }],
                    mediaOptions.min,
                )}
        `,
    },
};

Object.assign(orderStatusFormStyles, {
    form: {
        css: css`
            display: flex;
            margin-bottom: 25px;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        { values: [null, "flex-end", null, null, null], properties: ["align-items"] },
                        { values: ["column", "row", null, null, null], properties: ["flex-direction"] },
                    ],
                    mediaOptions.min,
                )}

            @media print {
                display: none;
            }
        `,
    },
    orderNumberTextField: {
        ...formLabelStyles,
    },
    emailOrPostalCodeTextField: {
        ...formLabelStyles,
    },
    submitButton: {
        variant: "primary",
    },
});
